import { Component } from '@angular/core';

@Component({
    selector: 'app-advent-calendar',
    templateUrl: './advent-calendar.component.html',
    styleUrls: ['./advent-calendar.component.scss'],
    standalone: true
})
export class AdventCalendarComponent {
  constructor() { }
}
